import styled from "styled-components";

const ParceriaContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;

export default ParceriaContainer;
